

import about from '../../api/about'

export default {
    data(){
        return {
            texts : {

            }
        }
    },

    created(){
        about.getCompanyProfile({}).then(res=>{
            this.texts = res;
            console.log(res)
        })
    }
}